
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/p/[...uri]",
      function () {
        return require("private-next-pages/p/[...uri].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/p/[...uri]"])
      });
    }
  